export default class EnderecoData {
    id = null
    endereco = null
    tipoLogradouro = null
    logradouro = null
    complemento = null
    numero = null
    bairro = null
    municipio = null
    uf = null
    cep = null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/enderecomodel.js